import { takeLatest, put } from 'redux-saga/effects';
import { reinviteMembersAction } from '../actions';
import { MembersAPI } from '../api';
import { addMembers } from '../slice';
function* inviteMembers(payload, handleSuccess) {
    const users = yield MembersAPI.inviteMembers(payload);
    yield put(addMembers(users));
    if (handleSuccess) {
        handleSuccess();
    }
}
function* resendMemberInvitationSaga(action) {
    const { payload: { data, handleAlways = ()=>{}, handleSuccess, handleFailure = ()=>{} } } = action;
    try {
        const payload = data;
        yield inviteMembers(payload, handleSuccess);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        handleFailure();
    }
    handleAlways();
}
export const watchResendMemberInvitationSaga = function*() {
    yield takeLatest(reinviteMembersAction.type, resendMemberInvitationSaga);
};
